import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

import Upload from '../hooks/useDirectUpload/Upload';

type UploadContextType = {
  uploads: Upload[];
  setUploads: React.Dispatch<React.SetStateAction<Upload[]>>;
  updateUpload: (upload: Upload) => void;
  getNextSequentialId: () => string;
};

const UploadContext = createContext<UploadContextType | null>(null);

export function UploadProvider({ children }: { children: React.ReactNode }) {
  const [uploads, setUploads] = useState<Upload[]>([]);
  const sequentialId = useRef(1);

  const updateUpload = useCallback((upload: Upload) => {
    setUploads((uploads) => uploads.map((x) => (x.id !== upload.id ? x : new Upload(upload))));
  }, []);

  const getNextSequentialId = useCallback(() => {
    return '' + sequentialId.current++;
  }, []);

  return <UploadContext value={{ uploads, setUploads, updateUpload, getNextSequentialId }}>{children}</UploadContext>;
}

export function useUploadContext() {
  return useContext(UploadContext);
}
